export interface Options {
  title?: string;
  target?: string;
  specs?: string[];
  styles?: string[];
  inlineStyle?: string;
}

class DefaultOptions implements Options {
  public target = "_blank";
  public specs = ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"];
  public styles = [];
  public inlineStyle = "";
}

export const install = (app, options: Options = {}) => {
  const printHtml = (id: string, localOptions: Options, cb = () => true) => {
    const { title, target, specs, styles, inlineStyle } = Object.assign(
      new DefaultOptions(),
      options,
      localOptions
    );
    const element = window.document.getElementById(id);

    if (!element) {
      alert(`Element to print #${id} not found!`);
      return;
    }

    const url = "";
    const win = openWindow(url, target, specs.join(","));

    win.document.write(`
        <html>
          <head>
            <title>${title || window.document.title}</title>
            <style>${inlineStyle}</style>
          </head>
          <body>
            ${element.outerHTML}
          </body>
        </html>
      `);

    addStyles(win, styles);

    setTimeout(() => {
      win.document.close();
      win.focus();
      win.print();
      setTimeout(function () {
        window.close();
      }, 1);
      cb();
    }, 1000);

    return true;
  };

  app.config.globalProperties.$printHtml = printHtml;
  app.provide("printHtml", printHtml);
};

function addStyles(win, styles) {
  styles.forEach((style) => {
    const link = win.document.createElement("link");
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("type", "text/css");
    link.setAttribute("href", style);
    win.document.getElementsByTagName("head")[0].appendChild(link);
  });
}

function openWindow(url, target, props) {
  const windowRef = window.open(url, target, props);
  if (!windowRef) {
    throw "window was not opened";
  }
  if (!windowRef.opener) {
    windowRef.opener = self;
  }
  windowRef.focus();

  return windowRef;
}
